import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import React from 'react';

import { EPrivacyStatus } from '@common/types';

type TPrivacyTagProps = {
  status: keyof typeof EPrivacyStatus;
};

export const PrivacyTag = ({ status }: TPrivacyTagProps): React.JSX.Element => {
  let tag = (
    <Tag color="default" icon={<SyncOutlined spin />}>
      {status}
    </Tag>
  );
  switch (status) {
    case EPrivacyStatus.PUBLIC:
      tag = (
        <Tag color="success" icon={<CheckCircleOutlined />}>
          {status}
        </Tag>
      );
      break;
    case EPrivacyStatus.PRIVATE:
      tag = (
        <Tag color="error" icon={<ExclamationCircleOutlined />}>
          {status}
        </Tag>
      );
      break;
  }

  return tag;
};
